import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles, createStyles } from '@material-ui/core/styles';
import { translate, userLogin } from 'ra-core';

const styles = () => createStyles({
  form: {
    padding: '0 1em 1em 1em'
  },
  input: {
    marginTop: '1em'
  },
  button: {
    width: '100%'
  }
});

const renderInput = ({
  meta: { touched, error } = { touched: false, error: '' },
  input: { ...inputProps },
  ...props
}) => (
    <TextField
      error={!!(touched && error)}
      helperText={touched && error}
      {...inputProps}
      {...props}
      fullWidth
    />
  );

const login = (auth, dispatch, { redirectTo }) =>
  dispatch(userLogin(auth, redirectTo));

type Props = {
  classes: any,
  isLoading: boolean,
  handleSubmit: any,
  translate: any
};

const LoginForm = ({ classes, isLoading, handleSubmit, translate }: Props) => (
  <form onSubmit={handleSubmit(login)}>
    <div className={classes.form}>
      <div className={classes.input}>
        <Field
          autoFocus
          id="username"
          name="username"
          component={renderInput}
          label="Email"
          disabled={isLoading}
        />
      </div>
      <div className={classes.input}>
        <Field
          id="password"
          name="password"
          component={renderInput}
          label={translate('ra.auth.password')}
          type="password"
          disabled={isLoading}
        />
      </div>
    </div>
    <CardActions>
      <Button
        variant="raised"
        type="submit"
        color="primary"
        disabled={isLoading}
        className={classes.button}
      >
        {isLoading && <CircularProgress size={25} thickness={2} />}
        {translate('ra.auth.sign_in')}
      </Button>
    </CardActions>
    <CardActions>
      <div style={{ width: '100%', textAlign: 'center', color: 'rgba(0, 0, 0, 0.298039)', padding: '5 10 10 10' }}>
        For guest access to documentation<br /> use: guest / guest
      </div>
    </CardActions>
  </form>
);

const mapStateToProps = state => ({ isLoading: state.admin.loading > 0 });

const enhance = compose(
  withStyles(styles),
  translate,
  connect(mapStateToProps),
  reduxForm({
    form: 'signIn',
    validate: (values, props) => {
      const errors = { username: null, password: null };
      const { translate } = props;

      if (!values.username)
        errors.username = translate('ra.validation.required');
      if (!values.password)
        errors.password = translate('ra.validation.required');
      return errors;
    }
  })
);

export default enhance(LoginForm);



// WEBPACK FOOTER //
// ./src/views/Framework/LoginForm.tsx